import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback, useEffect, useRef } from '@redneckz/uni-jsx/lib/hooks';
import { style } from '../../utils/style.js';
import { inputValidStyle } from './inputValidStyle.js';
import { renderLabel } from './renderLabel.js';
export const Input = JSX(({ key, className = '', id, name, type = 'text', label, placeholder, value = '', valid = true, children, onChange, onFocus, onBlur, pattern, autoFocus = false, isTextarea = false, }) => {
    const inputRef = useRef(null);
    const handleChange = useCallback((e) => {
        onChange && onChange(e.target?.value || '');
    }, [onChange]);
    useEffect(() => {
        if (autoFocus) {
            inputRef.current?.focus();
        }
    }, [autoFocus, inputRef]);
    const defaultStyle = 'w-full border rounded-md text-primary-text outline-none p-m';
    const paddingStyle = children ? 'pr-3xl' : '';
    const validStyle = getValidStyle(valid);
    return (_jsxs("div", { className: style('relative', className), children: [_jsxs("label", { className: "space-y-xs", children: [renderLabel(label), isTextarea ? (_jsx("textarea", { className: style('block resize-y min-h-24', defaultStyle, validStyle), id: style('textarea', id), name: name || id, placeholder: placeholder, value: value, onChange: handleChange, onFocus: onFocus, onBlur: onBlur }, key)) : (_jsx("input", { type: type, className: style('h-14', defaultStyle, paddingStyle, validStyle), ref: inputRef, id: id, name: name || id, placeholder: placeholder, value: value, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, pattern: pattern }, key))] }), children] }));
});
const getValidStyle = (valid) => (valid ? inputValidStyle : 'border-error');
//# sourceMappingURL=Input.js.map